import { Service } from '@angular/core';

@Service()
export class LanguageService {
  mapLocaleToLanguage(locale: string | undefined): string {
    const localeMap: Record<string, string> = {
      '1': 'no',
      '2': 'se',
      '3': 'en',
      '4': 'da',
      '5': 'fi',
    };
    return localeMap[locale || '1'] || 'no';
  }
}
